export default __webpack_public_path__ + "static/media/router-24px.c05941d6.svg";